import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';

function SavedSearchMonitorTogglerUI() {

    this.defaultAttrs({
        idAttribute: 'data-search-form-monitor-id',
        savedSearchTogglerElement: '[data-search-form-monitor-id]',
        savedSearchTogglerLabelElement: '[data-search-form-monitor-label]',
        disabledClass: 'disabled'
    });

    this._onToggleChange = function (element) {
        let eventName,
            payload;

        if (element.is(':checked')) {
            eventName = 'ui:saved-searches:on-monitor-start';
            payload = {
                SearchId: element.attr(this.attr.idAttribute),
                SendMail: true,
                element: element
            };
        } else {
            eventName = 'ui:saved-searches:on-monitor-stop';
            payload = {
                SearchId: element.attr(this.attr.idAttribute),
                SendMail: false,
                element: element
            };
        }

        element.addClass(this.attr.disabledClass); // Avoid double clicks or slow connections clicking twice
        this.trigger(eventName, payload);
    };

    this._monitoringCallback = function (evt, payload) {
        let sendMail = payload.sendMail,
            element = payload.element;

        if (element.is(':checkbox')) {
            element.attr('checked', sendMail);
            element.removeClass(this.attr.disabledClass);
        }
    };

    this._clickOnCheckbox = function (evt, options) {
        evt.stopPropagation(); // If the checkbox is inside a <label>, this._clickOnLabel will be triggered unless propagation is stopped

        let element = $(options.el);

        if (element.hasClass(this.attr.disabledClass)) {
            evt.preventDefault();
            return false;
        }

        this._onToggleChange(element);
    };

    this._clickOnLabel = function (evt, options) {
        let element = $(options.el);
        if (!element.is('label')) { // Make sure the clicked element is a label, this is just a guard
            return;
        }

        // IE8 doesnt trigger the change-event after changing a hidden checkbox' checked-property, so if its a label (with 'for' attribute) use this code
        if (element.attr('for')) {
            evt.preventDefault();
            evt.stopPropagation();
            let input = $('#' + element.attr('for'));
            if (input.length > 0) {
                input.click();
            }
        }
    };

    this.after('initialize', function () {
        this.on('click', {
            savedSearchTogglerElement: this._clickOnCheckbox
        });

        this.on('click', {
            savedSearchTogglerLabelElement: this._clickOnLabel
        });

        this.on(document, 'data:saved-searches:after-monitor-start data:saved-searches:after-monitor-stop', this._monitoringCallback);
    });
}

module.exports = defineComponent.component(SavedSearchMonitorTogglerUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/saved-search-monitor-toggler-ui.js